import type {ILogService, IRootScopeService} from 'angular';
import register from '@kpsys/angularjs-register';
import {isPromise} from './custom-utils';


let _$injector: angular.auto.IInjectorService;

/**
 * This function must be inserted to `run` method of `angular.module`.
 * It is necessary for correct running of `@ngDecorators`.
 *
 * @param {IInjectorService} $injector
 *
 * @example
 * ```
 *      angular.module('myModule', []).run(initNgDecoratorsHelper);
 * ```
 */
export function initNgDecoratorsHelper($injector: angular.auto.IInjectorService) {
    'ngInject';

    _$injector = $injector;
}

export const __ngAsyncDecoratorInternalAPI = {
    clearInjector: () => {
        _$injector = undefined;
    }
};

/**
 * Decorator, which triggers digest cycle when promise from decorated promise-returning function is fulfilled or rejected.
 * It is for async functions.
 */
export function ngAsync() {
    return function ngAsyncFunction(target, key, descriptor) {

        const fn = descriptor.value;
        descriptor.value = function (...args) {
            if (!_$injector) {
                throw new TypeError('Cannot apply @ngAsync decorator. Probably \'ngDecoratorsHelper\' is not registered as dependent module.');
            }

            const result = fn.apply(this, args);

            if (isPromise(result)) {
                _$injector.invoke(/*@ngInject*/ ($rootScope: IRootScopeService) => {

                    const applyRootScope = (value) => {
                        $rootScope.$applyAsync();
                        return value;
                    };

                    result.then(applyRootScope, applyRootScope);
                });
            } else {
                _$injector.invoke(/*@ngInject*/ ($log: ILogService) =>
                    $log.warn('Result is not Promise-like value. @ngAsync decorator is not applied.'));
            }

            return result;
        };
    };
}

export default register('portaro.shared.ngDecoratorsHelper')
    .run(initNgDecoratorsHelper)
    .name();
